import { createRouteConfig } from 'modules/router/utils/createRouteConfig';

export const PATH_BILLING = '/account/';
export const PATH_CARDPAYMENT_SUCCESS = `${PATH_BILLING}success/`;
export const PATH_CARDPAYMENT_FAILURE = `${PATH_BILLING}failure/`;

export const billingRoutesConfig = createRouteConfig(
  {
    billing: {
      path: PATH_BILLING,
      generatePath: () => PATH_BILLING,
    },
    cardPaymentSuccess: {
      path: PATH_CARDPAYMENT_SUCCESS,
      generate: () => PATH_CARDPAYMENT_SUCCESS,
    },
    cardPaymentFailure: {
      path: PATH_CARDPAYMENT_FAILURE,
      generate: () => PATH_CARDPAYMENT_FAILURE,
    },
  },
  PATH_BILLING,
);
